export const queuesTableColumns = [
  {
    title: "Nombre de la cola",
    key: "name",
    dataIndex: "name",
    width: 280,
    ellipsis: true,
  },
  {
    title: "Identificadores asociados",
    key: "channels_customer",
    dataIndex: "channels_customer",
    slots: { customRender: "channels_customer" },
    width: 210,
  },
  {
    title: "Campañas",
    key: "portfolios",
    dataIndex: "portfolios",
    slots: { customRender: "portfolios" },
    width: 180,
    ellipsis: true,
  },
  {
    title: "Tiempo de NS",
    key: "level_service",
    dataIndex: "level_service",
    slots: { customRender: "level_service" },
    width: 160,
  },
  // {
  //   title: "Umbral",
  //   key: "waiting_threshold",
  //   dataIndex: "waiting_threshold",
  //   slots: { customRender: "waiting_threshold" },
  //   width: 140,
  // },
  // {
  //   title: "Supervisores",
  //   key: "supervisors",
  //   dataIndex: "supervisors",
  //   width: 160,
  //   slots: { customRender: "supervisors" },
  // },
  {
    title: "Total de usuarios",
    key: "agents",
    dataIndex: "agents",
    width: 160,
    slots: { customRender: "agents" },
  },
  {
    title: "Prioridad",
    key: "priority",
    dataIndex: "priority",
    width: 120,
    slots: { customRender: "priority" },
  },
  {
    title: "Estado",
    key: "status",
    dataIndex: "status",
    width: 160,
    slots: { customRender: "status" },
  },
  {
    title: "Acciones",
    key: "actions",
    dataIndex: "status",
    slots: { customRender: "actions" },
    width: 160,
    fixed: "right",
  },
];
